module.exports = __webpack_public_path__ + "media/images/emblems/Fischbach_LU-c162b80d059bddbeb9c85569e15cea77.png";